import { BdsGrid, BdsIllustration, BdsTypo } from 'blip-ds/dist/blip-ds-react/components';
import { useTranslation } from 'react-i18next';
import './styles.scss';

export function NoHistory() {
    const { t } = useTranslation();
    return (
        <BdsGrid direction="column" alignItems="center" gap="1" margin="t-4">
            <BdsGrid height="176px">
                <BdsIllustration name="agent-1" type="empty-states" />
            </BdsGrid>
            <BdsGrid direction="column" alignItems="center">
                <BdsTypo className="no-history-text-center" variant="fs-20" lineHeight="none" bold="bold">
                    {t('go-personal-no-history-title')}
                </BdsTypo>
                <BdsTypo className="no-history-text-center" variant="fs-16">
                    {t('go-personal-no-history-description')}
                </BdsTypo>
            </BdsGrid>
        </BdsGrid>
    );
}
